export default __webpack_public_path__ + "static/media/landing-background.a6155280.png";